import { useState } from "react"

export const useTicketState = () => {
  const [state, setState] = useState({
    mailAddress: "",
    phoneNumber: "nicht angegeben",
    companyName: "nicht angegeben",
    validEmail: false,
    buttonLoading: false,
    ticketText: "",
    ticketSubject: "",
    successModalClass: "",
    failModalClass: "",
    checkboxDatenschutz: false,
    customerName: "",
    recallTime: "",
    currentTime: "",
  })

  const setTicketState = (param, value) => {
    setState({
      ...ticketState,
      [param]: value,
    })
  }
  let ticketState = state

  const updateTicketSubject = (e) =>
    setTicketState("ticketSubject", e.target.value)

  const updateMailAddress = (e) => setTicketState("mailAddress", e.target.value)

  const updatePhoneNumber = (e) => setTicketState("phoneNumber", e.target.value)

  const updateCompanyName = (e) => setTicketState("companyName", e.target.value)

  const updateTicketText = (e) => setTicketState("ticketText", e.target.value)

  const updateCustomerName = (e) =>
    setTicketState("customerName", e.target.value)

  const updateRecallTime = (e) => setTicketState("recallTime", e.target.value)

  const datenschutzToggle = (e) => {
    e.target.tagName !== "A" && e.preventDefault()
    setTicketState("checkboxDatenschutz", !ticketState.checkboxDatenschutz)
  }

  return {
    setState,
    ticketState,
    setTicketState,
    datenschutzToggle,
    updateTicketSubject,
    updateMailAddress,
    updatePhoneNumber,
    updateCompanyName,
    updateTicketText,
    updateCustomerName,
    updateRecallTime,
  }
}
